<button mat-button mat-stroked-button class="tab-btn" [class.active]="navTab?.activeTab" routerLink="{{navTab?.url}}" type="button">
		<span class="tab-btn-label">{{navTab?.tag}}</span>
		<button mat-button type="button" class="tab-btn-close" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
</button>